import styles from './Switch.module.css';

interface SwitchProps {
  checked: boolean;
  onChange: () => void;
}

/**
 * The app's on/off switch: a visually-hidden checkbox driving a token-styled
 * track, the way `Checkbox` draws its box.
 *
 * A switch and not a checkbox, because the two answer different questions. A
 * checkbox is a pick: this option, among others, on a form submitted later. A
 * switch is a state that takes effect as it is pressed, and a tick in a box
 * beside "Compact" reads as an option being collected rather than as the list
 * changing under it. `role="switch"` says the same thing to a screen reader.
 *
 * Carries no name of its own: wrap it in the `<label>` that names it.
 */
export function Switch({ checked, onChange }: SwitchProps) {
  return (
    <span className={styles.switch}>
      <input type="checkbox" role="switch" checked={checked} onChange={() => onChange()} />
      <span className={styles.track} aria-hidden="true">
        <span className={styles.knob} />
      </span>
    </span>
  );
}
